import * as focusTrap from "focus-trap"; // ESM
import MainNavigationControl from "./MainNavigationControl";

/**
 * The main navigation class that initialises all the controls
 * nested inside itself. Indicated by the data attribute:
 *  [data-main-nav]
 */
export default class MainNavigation {
  /**
   * Static active class, should not change unless altered from the CSS
   * for some reason
   *
   * Used to animate the menu content targets
   */
  static activeClass = "active";

  /**
   * Static locked class, should not change unless altered from the CSS
   * for some reason
   *
   * Used to lock the body content from
   */
  static lockedClass = "locked";

  /**
   * Static transition class, should not change unless altered from the CSS
   * for some reason
   *
   * Applied at the start of the opening transition
   * Removed at the end of the closing transition
   */
  static transitionClass = "transitioning";

  /**
   * The active target for the MainNavigationControl classes
   * Serves as a single point of reference for all controls in the
   * Main Navigation
   */
  static activeTarget = "";

  /**
   * The focus trap functionality for the main navigation
   * Serves as a single point of reference for all controls in the
   * Main Navigation to control the focus trap
   */
  static focusTrap = () => {};

  /**
   * Construct the main navigation functionality from its root
   * Find the menu, controls and their targets through data attributes:
   *  [data-control-menu]
   *  [data-control]
   *  [data-controlled-by]
   *
   * Passes this data through as config for each Control to keep track of.
   *
   * @param {HTMLDivElement} element
   */
  constructor(element) {
    this.page = document.querySelector(".page-wrapper");
    this.root = element;
    this.menu = this.root.querySelector("[data-control-menu]");
    this.header = this.root.querySelector(".main-navigation__main");

    this.targets = this.root.querySelectorAll("[data-controlled-by]");
    this.controls = [];
    // Focus Trap
    MainNavigation.setFocusTrap(
      focusTrap.createFocusTrap(this.root, { initialFocus: false })
    );

    // Initialise all the controls
    const controlBtns = this.root.querySelectorAll("[data-control='main-nav']");

    controlBtns.forEach((control) => {
      // Push each control to the controls property for reference by the controls
      this.controls.push(
        new MainNavigationControl({
          element: control,
          page: this.page,
          root: this.root,
          menu: this.menu,
          header: this.header,
          controls: this.controls,
          allTargets: this.targets,
        })
      );
    });

    window.addEventListener("resize", () => {
      if (this.controls.length) {
        this.controls.forEach((c) => {
          c.handleTabIndex();
        });
      }
    });
  }

  // Controls which target is currently open for the buttons
  static setActiveTarget(value) {
    MainNavigation.activeTarget = value;
  }

  // Assign focus trap to the main navigation
  static setFocusTrap(value) {
    MainNavigation.focusTrap = value;
  }
}
